import Stripe from "../../assets/images/PaymentMethod/stripe.png";
import PayPal from "../../assets/images/PaymentMethod/paypal.png";
import ApplePay from "../../assets/images/PaymentMethod/applepay.png";
import AmazonPay from "../../assets/images/PaymentMethod/amazonpay.png";
import GooglePay from "../../assets/images/PaymentMethod/googlepay.png";
import google from "../../assets/images/social-media/google.png";
import apple from "../../assets/images/social-media/apple.png";
import dribbble from "../../assets/images/social-media/dribbble.png";
import facebook from "../../assets/images/social-media/facebook.png";
import github from "../../assets/images/social-media/github.png";
import gitlab from "../../assets/images/social-media/gitlab.png";
import instagram from "../../assets/images/social-media/instagram.png";
import linkedin from "../../assets/images/social-media/linkedin.png";
import medium from "../../assets/images/social-media/medium.png";
import pinterest from "../../assets/images/social-media/pinterest.png";
import reddit from "../../assets/images/social-media/reddit.png";
import snapchat from "../../assets/images/social-media/snapchat.png";
import stackoverflow from "../../assets/images/social-media/stackoverflow.png";
import telegram from "../../assets/images/social-media/telegram.png";
import threads from "../../assets/images/social-media/threads.png";
import tiktok from "../../assets/images/social-media/tiktok.png";
import twitter from "../../assets/images/social-media/twitter.png";
import whatsapp from "../../assets/images/social-media/whatsapp.png";
import youtube from "../../assets/images/social-media/youtube.png";

export const status_filter = [
  { name: "Active", value: "active", type: "checkbox" },
  { name: "Inactive", value: "inactive", type: "checkbox" },
];
export const email_verified = [
  { name: "Email Verified", value: 1, type: "checkbox" },
  { name: "Email Not Verified", value: 2, type: "checkbox" },
];
export const featured_filter = [
  { name: "Yes", value: true, type: "checkbox" },
  { name: "No", value: false, type: "checkbox" },
];
export const trending_filter = [
  { value: 1, name: "Trending", type: "checkbox" },
  { value: 0, name: "Non-trending", type: "checkbox" },
];
export const approved_filter = [
  { value: true, name: "Approved", type: "checkbox" },
  { value: false, name: "Non-approved", type: "checkbox" },
];
export const member_filter = [
  { value: true, name: "Member", type: "checkbox" },
  { value: false, name: "Not-member", type: "checkbox" },
];
export const email_filter = [
  { value: 1, name: "Verified", type: "checkbox" },
  { value: 2, name: "Not-verified", type: "checkbox" },
];
export const attr_filter = [
  { value: true, name: "Value", type: "checkbox" },
  { value: false, name: "Attribute", type: "checkbox" },
];
export const yes_no_filter = [
  { value: 1, name: "Yes", type: "checkbox" },
  { value: 0, name: "No", type: "checkbox" },
];
export const invitation_filter = [
  { value: 1, name: "Yes", type: "checkbox" },
  { value: 2, name: "No", type: "checkbox" },
];
export const role_filter = [
  { value: "COMPANY-ADMINISTRATOR", name: "Administrator", type: "checkbox" },
  // { value: "COMPANY-MANAGER", name: "Evaluator", type: "checkbox" },
  { value: "COMPANY-EMPLOYEE", name: "Employee", type: "checkbox" },
];
export const order_status_filter = [
  { value: "processing", name: "Processing", type: "checkbox" },
  { value: "shipped", name: "Shipped", type: "checkbox" },
  { value: "delivered", name: "Delivered", type: "checkbox" },
  { value: "cancelled", name: "Cancelled", type: "checkbox" },
];
export const payment_status_filter = [
  { value: "pending", name: "Pending", type: "checkbox" },
  { value: "success", name: "Success", type: "checkbox" },
  { value: "failed", name: "Failed", type: "checkbox" },
];
export const payment_method_filter = [
  { value: "online", name: "Online", type: "checkbox" },
  { value: "cash", name: "Cash", type: "checkbox" },
];
export const application_status_filter = [
  { value: "submitted", name: "Submitted", type: "checkbox" },
  { value: "reviewed", name: "Reviewed", type: "checkbox" },
  { value: "shortlisted", name: "Shortlisted", type: "checkbox" },
  { value: "hired", name: "Hired", type: "checkbox" },
  { value: "rejected", name: "Rejected", type: "checkbox" },
  { value: "withdrawn", name: "Withdrawn", type: "checkbox" },
];

export const eventTypes = {
  birthDay: {
    icon: "fa-regular fa-cake-candles",
    color: "text-red-500 bg-red-50",
    hover: "hover:bg-danger-light",
    border: "border-red-300",
    selected: "!bg-red-500 !text-white",
  },
  marriage: {
    icon: "fa-regular fa-ring-diamond",
    color: "text-blue-500 bg-blue-50",
    hover: "hover:bg-blue-100",
    border: "border-blue-300",
    selected: "!bg-blue-500 !text-white",
  },
  holiday: {
    icon: "fa-regular fa-umbrella-beach",
    color: "text-green-500 bg-green-50",
    hover: "hover:bg-green-100",
    border: "border-green-300",
    selected: "!bg-green-500 !text-white",
  },
  leave: {
    icon: "fa-regular fa-house-person-leave",
    color: "text-yellow-500 bg-yellow-50",
    hover: "hover:bg-yellow-100",
    border: "border-yellow-300",
    selected: "!bg-yellow-500 !text-white",
  },
  announcement: {
    icon: "fa-regular fa-bullhorn",
    color: "text-purple-500 bg-purple-50",
    hover: "hover:bg-purple-100",
    border: "border-purple-300",
    selected: "!bg-purple-500 !text-white",
  },
};

export const nestedDep = [
  {
    _id: "6721e849f8d87791ef96217b",
    name: "Marketing department",
    code: "marketing-department",
    parentId: null,
    color: "#FF5733",
    children: [
      {
        _id: "674580f05df35d559e1a34c6",
        name: "asdfvgbn",
        code: "asdfvgbn",
        parentId: "6721e849f8d87791ef96217b",
        color: "#FF7043",
        children: [
          {
            _id: "child-level3-1",
            name: "Sub-Department 1",
            code: "sub-department-1",
            parentId: "674580f05df35d559e1a34c6",
            color: "#FF8A65",
            children: [
              {
                _id: "child-level4-1",
                name: "Team 1",
                code: "team-1",
                parentId: "child-level3-1",
                color: "#FFB74D",
                children: [],
              },
            ],
          },
          {
            _id: "child-level3-2",
            name: "Sub-Department 2",
            code: "sub-department-2",
            parentId: "674580f05df35d559e1a34c6",
            color: "#FFCC80",
            children: [],
          },
        ],
      },
      {
        _id: "6721e82df8d87791ef96216b",
        name: "Design Departmentsss",
        code: "design-department",
        parentId: "6721e849f8d87791ef96217b",
        color: "#3F51B5",
        children: [
          {
            _id: "child-level3-3",
            name: "Graphic Design",
            code: "graphic-design",
            parentId: "6721e82df8d87791ef96216b",
            color: "#7986CB",
            children: [
              {
                _id: "child-level4-2",
                name: "UI/UX Team",
                code: "ui-ux-team",
                parentId: "child-level3-3",
                color: "#9FA8DA",
                children: [],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    _id: "6721e854f8d87791ef962183",
    name: "Analysis Departments",
    code: "analysis-department",
    parentId: null,
    color: "#4CAF50",
    children: [
      {
        _id: "672b41d0147584d589b175c5",
        name: "Procurement",
        code: "procurement",
        parentId: "6721e854f8d87791ef962183",
        color: "#66BB6A",
        children: [
          {
            _id: "child-level3-4",
            name: "Vendor Management",
            code: "vendor-management",
            parentId: "672b41d0147584d589b175c5",
            color: "#81C784",
            children: [],
          },
        ],
      },
      {
        _id: "672b4180147584d589b17562",
        name: "Finance and Accounting",
        code: "finance-and-accounting",
        parentId: "6721e854f8d87791ef962183",
        color: "#388E3C",
        children: [
          {
            _id: "child-level3-5",
            name: "Auditing",
            code: "auditing",
            parentId: "672b4180147584d589b17562",
            color: "#43A047",
            children: [
              {
                _id: "child-level4-3",
                name: "Internal Audit Team",
                code: "internal-audit-team",
                parentId: "child-level3-5",
                color: "#66BB6A",
                children: [],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    _id: "6745753ac4cf1092fec4df68",
    name: "Research and Development",
    code: "research-and-development",
    parentId: null,
    color: "#00BCD4",
    children: [
      {
        _id: "672b41e8147584d589b175d7",
        name: "Training and Development",
        code: "training-and-development",
        parentId: "6745753ac4cf1092fec4df68",
        color: "#26C6DA",
        children: [
          {
            _id: "child-level3-6",
            name: "Employee Training",
            code: "employee-training",
            parentId: "672b41e8147584d589b175d7",
            color: "#4DD0E1",
            children: [
              {
                _id: "child-level4-4",
                name: "Technical Training",
                code: "technical-training",
                parentId: "child-level3-6",
                color: "#80DEEA",
                children: [],
              },
            ],
          },
        ],
      },
    ],
  },
];

export const PAYMENT_STATUS = {
  initiated: {
    label: "Initiated",
    class: "bg-gray-100 text-gray-700 border border-gray-200",
  },
  active: {
    label: "Active",
    class: "bg-green-100 text-green-700 border border-green-200",
  },
  cancelled: {
    label: "Cancelled",
    class: "bg-red-100 text-red-700 border border-red-200",
  },
  expired: {
    label: "Expired",
    class: "bg-yellow-100 text-yellow-700 border border-yellow-200",
  },
  incomplete: {
    label: "Incomplete",
    class: "bg-amber-100 text-amber-700 border border-amber-200",
  },
  trialing: {
    label: "Trialing",
    class: "bg-blue-100 text-blue-700 border border-blue-200",
  },
  past_due: {
    label: "Past Due",
    class: "bg-orange-100 text-orange-700 border border-orange-200",
  },
  refunded: {
    label: "Refunded",
    class: "bg-emerald-100 text-emerald-700 border border-emerald-200",
  },
  failed: {
    label: "Failed",
    class: "bg-rose-100 text-rose-700 border border-rose-200",
  },
};

export const PAYMENT_METHOD = {
  stripe: {
    label: "Stripe",
    icon: Stripe,
    class: "bg-transparent text-[#635BFF]",
  },
  paypal: {
    label: "PayPal",
    icon: PayPal,
    class: "bg-transparent text-[#003087]",
  },
  googlepay: {
    label: "Google Pay",
    icon: GooglePay,
    class: "bg-transparent text-[#4285F4]",
  },
  applepay: {
    label: "Apple Pay",
    icon: ApplePay,
    class: "bg-transparent text-[#1e1e1e]",
  },
  amazonpay: {
    label: "Amazon Pay",
    icon: AmazonPay,
    class: "bg-transparent text-[#FF9900]",
  },
};

export const SOCIAL_MEDIA = [
  {
    label: "Apple",
    value: "apple",
    icon: apple,
    class: "bg-transparent text-black",
  },
  {
    label: "Dribbble",
    value: "dribbble",
    icon: dribbble,
    class: "bg-transparent text-pink-500",
  },
  {
    label: "Facebook",
    value: "facebook",
    icon: facebook,
    class: "bg-transparent text-[#1877F2]",
  },
  {
    label: "GitHub",
    value: "github",
    icon: github,
    class: "bg-transparent text-black",
  },
  {
    label: "GitLab",
    value: "gitlab",
    icon: gitlab,
    class: "bg-transparent text-orange-500",
  },
  {
    label: "Google",
    value: "google",
    icon: google,
    class: "bg-transparent text-[#003087]",
  },
  {
    label: "Instagram",
    value: "instagram",
    icon: instagram,
    class: "bg-transparent text-pink-600",
  },
  {
    label: "LinkedIn",
    value: "linkedin",
    icon: linkedin,
    class: "bg-transparent text-[#0077B5]",
  },
  {
    label: "Medium",
    value: "medium",
    icon: medium,
    class: "bg-transparent text-black",
  },
  {
    label: "Pinterest",
    value: "pinterest",
    icon: pinterest,
    class: "bg-transparent text-red-600",
  },
  {
    label: "Reddit",
    value: "reddit",
    icon: reddit,
    class: "bg-transparent text-orange-400",
  },
  {
    label: "Snapchat",
    value: "snapchat",
    icon: snapchat,
    class: "bg-transparent text-yellow-400",
  },
  {
    label: "Stack Overflow",
    value: "stackoverflow",
    icon: stackoverflow,
    class: "bg-transparent text-orange-600",
  },
  {
    label: "Telegram",
    value: "telegram",
    icon: telegram,
    class: "bg-transparent text-[#0088cc]",
  },
  {
    label: "Threads",
    value: "threads",
    icon: threads,
    class: "bg-transparent text-black",
  },
  {
    label: "TikTok",
    value: "tiktok",
    icon: tiktok,
    class: "bg-transparent text-black",
  },
  {
    label: "Twitter",
    value: "twitter",
    icon: twitter,
    class: "bg-transparent text-black",
  },
  {
    label: "WhatsApp",
    value: "whatsapp",
    icon: whatsapp,
    class: "bg-transparent text-green-500",
  },
  {
    label: "YouTube",
    value: "youtube",
    icon: youtube,
    class: "bg-transparent text-red-600",
  },
];

export const mediaExtensions = {
  image: [
    ".jpg",
    ".jpeg",
    ".png",
    ".gif",
    ".bmp",
    ".webp",
    ".tiff",
    ".tif",
    ".svg",
    ".ico",
    ".heic",
    ".raw",
    ".psd",
    ".ai",
    ".eps",
  ],
  video: [
    ".mp4",
    ".mkv",
    ".mov",
    ".avi",
    ".wmv",
    ".flv",
    ".webm",
    ".3gp",
    ".mpeg",
    ".mpg",
    ".m4v",
    ".ts",
    ".vob",
    ".ogv",
    ".f4v",
    ".rm",
    ".rmvb",
  ],
  audio: [
    ".mp3",
    ".wav",
    ".aac",
    ".flac",
    ".ogg",
    ".oga",
    ".m4a",
    ".wma",
    ".amr",
    ".aiff",
    ".ape",
    ".opus",
    ".mid",
    ".midi",
    ".ra",
    ".ram",
    ".mpga",
    ".au",
    ".snd",
    ".mka",
    ".voc",
    ".weba",
    ".wv",
    ".aa",
    ".aax",
    ".cda",
    ".vox",
    ".ao",
  ],
  pdf: [".pdf"],
  word: [".doc", ".docx", ".dot", ".dotx", ".odt", ".rtf", ".wps", ".wpd"],
  excel: [".xls", ".xlsx", ".xlsm", ".xlsb", ".ods", ".csv", ".tsv"],
  ppt: [".ppt", ".pptx", ".pptm", ".pot", ".potx", ".odp"],
  csv: [".csv"],
  // archive: [
  //   ".zip", ".rar", ".7z", ".tar", ".gz", ".bz2", ".xz", ".iso", ".cab", ".arj", ".lz", ".z"
  // ],
  code: [
    ".txt",
    ".js",
    ".jsx",
    ".ts",
    ".tsx",
    ".json",
    ".html",
    ".htm",
    ".css",
    ".scss",
    ".php",
    ".py",
    ".java",
    ".c",
    ".cpp",
    ".h",
    ".cs",
    ".xml",
    ".yml",
    ".yaml",
    ".md",
    ".ini",
    ".log",
    ".env",
    ".sh",
    ".bat",
    ".pl",
    ".rb",
  ],
};

export const FILE_CATEGORIES = [
  { value: "all", label: "All", color: "text-gray-800" },
  { value: "image", label: "Images", color: "text-red-500" },
  { value: "video", label: "Videos", color: "text-purple-500" },
  { value: "pdf", label: "PDFs", color: "text-yellow-500" },
  { value: "word", label: "Word Docs", color: "text-pink-500" },
  { value: "excel", label: "Excel Sheets", color: "text-green-500" },
  { value: "ppt", label: "Presentations", color: "text-orange-500" },
  { value: "csv", label: "CSV Files", color: "text-amber-600" },
  { value: "audio", label: "Audio Files", color: "text-blue-500" },
  { value: "other", label: "Other Files", color: "text-gray-700" },
  { value: "recycle", label: "Recycle Bin", color: "text-gray-500" },
];
